import { Badge, Button } from '@/components/ui';
import { useAuth } from '@/app/providers';
import { supabase } from '@/lib/supabase';
import { toast } from '@/components/feedback/toast';
import { signInWithGoogle } from '@/features/auth/api/googleAuth';
import { authCallbackURL } from '@/features/auth/api/redirect';
import { CONNECTIONS } from '../../settings';
import { SettingsCard } from '../SettingsPrimitives';

export function ConnectionsTab() {
  const { user } = useAuth();
  const provider = (user?.app_metadata as { provider?: string } | undefined)?.provider ?? null;

  function connect(id: string) {
    if (id === 'discord') {
      void supabase.auth.signInWithOAuth({
        provider: 'discord',
        options: { redirectTo: authCallbackURL(), scopes: 'identify email' },
      });
      return;
    }
    if (id === 'google') {
      signInWithGoogle().catch((e: Error) => toast('Google connect failed: ' + e.message, 'error'));
      return;
    }
    toast(`${id.charAt(0).toUpperCase() + id.slice(1)} integration coming soon`, 'info');
  }

  return (
    <SettingsCard title="Connected accounts">
      <div className="flex flex-col gap-2">
        {CONNECTIONS.map((c) => {
          const connected = provider === c.id;
          return (
            <div
              key={c.id}
              className="flex items-center justify-between gap-3 rounded-xl border border-edge bg-white/[0.02] p-3 transition-all hover:-translate-y-px hover:border-card-line hover:bg-white/[0.04]"
            >
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/5 text-base">
                {c.icon || c.name.charAt(0)}
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-[13px] font-semibold text-hi">{c.name}</div>
                <div className="mt-0.5 text-[11px] text-lo">{c.meta}</div>
              </div>
              {connected ? (
                <Badge tone="success">Connected</Badge>
              ) : (
                <Button type="button" variant="subtle" size="sm" onClick={() => connect(c.id)}>
                  Connect
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </SettingsCard>
  );
}
